"use client";
import { useEffect } from "react";

const colors = {
  font: "#1f2022",
  alert: "#d63837",
};

const initialValues = {
  title: "WARNING!",
  titleStyle: [
    `color: ${colors.alert}`,
    "font-size: 40px",
    "font-weight: 600",
    `text-shadow: -1px 0 ${colors.font}, 0 1px ${colors.font}, 1px 0 ${colors.font}, 0 -1px ${colors.font}`,
    "line-height: 1.5",
    "padding-left: 1px",
    "padding-top: 16px",
  ],
  description: `The elements of the present website (including, but not limited to, source code, software, structure, design, trademarks, information texts, content, etc) are the exclusive property of the owner and operator of the present website. No licenses, express or implied, are granted to software developers, users and/or other third parties and copy, reproduce, publish, transform, provide, distribute, transmit, publicly communicate, display or make use,  totally or partially, of any of the elements of our website is totally prohibited.\nIs strictly forbidden to use (or contribute to an individual to do so) the web browser’s console used to access this website to insert and/or execute expressions, commands or codes that, directly or indirectly, interfere, manipulate and/or damage any element of this website, especially its source code.\nPlease be aware that this actions could involve, among others, (i) that your private information or personal data is sent to an unauthorized third party and/or the owner or operator of a false website and, consequently, they are stolen and/or processed for fraudulent purposes or (ii) that a malware can be installed on your computer to access your files (documents, photos, videos), camera, microphone, printer or devices connected to your computer, which would make your privacy more vulnerable. The copyright holder will not be liable for any direct or indirect, incidental, special, exemplary or consequential damages for an individual arising from, out of or in connection with the infringement of the present warning.\nThe owner and operator of this website reserves the right to take any and all necessary legal actions, including compensation for direct and indirect damages, at our disposal that it will be considered appropriate for the best defense of its legitimate rights and interests, in the event of an infringement of its intellectual property rights.`,
  descriptionStyle: ["line-height: 1.5", "padding-top: 16px", "padding-bottom: 16px"],
};

const AlertConsoleLog = () => {
  useEffect(() => {
    window.addEventListener("load", () => {
      console.info(`%c${initialValues.title}`, initialValues.titleStyle.join(";"));
      console.info(`%c${initialValues.description}`, initialValues.descriptionStyle.join(";"));
    });
  }, []);

  return null;
};

export default AlertConsoleLog;
